import { PremiumPaymentMode } from "../data/quoteInterfaces";
import { getPremiumAmount } from "../data/illustrationMapper";
import { useTranslation } from "react-i18next";
import React, { createContext, useContext, useState } from "react";

export interface IllustrationServiceTerm {
  premiumData: any,
  getPremiumAmount: (planId: number, insuredId: number) => number | null;
  getTotalPremium: () => number | null;
  getPremiumPaymentModeStr: () => string;
  getPolicyFee: () => number | null;
  hasData: boolean;
  setPremiumData: React.Dispatch<any>;
  setPremiumPaymentMode: React.Dispatch<PremiumPaymentMode>;
  resetPremiumData: () => void;
}

const PremiumInfoProvider = ({ children }: {children: React.ReactNode }) => {

  const { t } = useTranslation();
  const [premiumData, setPremiumData] = useState<any>();
  const [premiumPaymentMode, setPremiumPaymentMode] = useState<PremiumPaymentMode>(PremiumPaymentMode.Monthly);

  const resetPremiumData = () => setTimeout(() => setPremiumData(null), 0);

  const getPremiumAmountInt = (planId: number, insuredId: number): number | null => {
    const result =
      premiumData == null
        ? null
        : getPremiumAmount(
          premiumData.coverages,
          planId,
          premiumPaymentMode === PremiumPaymentMode.Monthly
            ? "monthlyPremium"
            : "annualPremium",
          insuredId
        );

    return result;
  };

  const getPremiumPaymentModeStr = () =>
    premiumPaymentMode === PremiumPaymentMode.Monthly
      ? t("month")
      : t("year");

  const getTotalPremium = (): number | null =>
    premiumData == null
      ? null
      : premiumPaymentMode === PremiumPaymentMode.Monthly
        ? premiumData.monthlyPremium
        : premiumData.annualPremium;

  const getPolicyFee = (): number | null =>
    premiumData == null
      ? null
      : premiumPaymentMode === PremiumPaymentMode.Monthly
        ? premiumData?.monthlyPolicyFee
        : premiumData?.annualPolicyFee;

  const obj: IllustrationServiceTerm = {
    premiumData,
    getPremiumAmount: getPremiumAmountInt,
    getPolicyFee,
    getTotalPremium,
    getPremiumPaymentModeStr,
    get hasData(): boolean {
      return premiumData != null;
    },
    setPremiumData,
    setPremiumPaymentMode,
    resetPremiumData
  };

  return (
    <PremiumInfoContext.Provider value={obj}>
      {children}
    </PremiumInfoContext.Provider>
  );
};

export const PremiumInfoContext = createContext<IllustrationServiceTerm>(undefined!);
export const usePremiumData = () => useContext(PremiumInfoContext);
export default PremiumInfoProvider;
